import styled from "styled-components";

import CustomButton from "../../../helperComponents/CustomButton";
import WithBackground from "../../../core/boilerplate/WithBackground";
import LoggedInHeader from "../LoggedInHeader";
import InputCard from "../../../helperComponents/InputCard";
import logout from "../../../../controllers/logout";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import { useContext } from "react";
import Context from "../../../../Context";
import adminAccess from "../../../../data/adminAccess";
import { useTranslation } from "react-i18next";
import TitleBar from "../../../helperComponents/TitleBar";
import LoadingSection from "../../../helperComponents/LoadingSection";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  align-items: center;
  gap: 50px;
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export default function SettingsPage() {
  const { loggedInUser } = useContext(Context);
  const { t } = useTranslation();

  if (!loggedInUser)
    return (
      <LoggedInBoilerplate showBackgroundImage={true}>
        <TitleBar>Paramètres</TitleBar>
        <LoadingSection />
      </LoggedInBoilerplate>
    );

  return (
    <LoggedInBoilerplate
      titleLine1={"page "}
      titleLine2={"de paramètres"}
      showBackgroundImage={true}
    >
      {/* <TitleBar> Paramètres </TitleBar> */}
      <Container>
        <Inputs>
          <CustomButton onClick={logout}> Déconnexion </CustomButton>

          <CustomButton href={`/employee/${loggedInUser._id}`}>
            Profil
          </CustomButton>

          <CustomButton href={`/change-password`}>
            changer le mot de passe
          </CustomButton>

          {/* <CustomButton href="/delete-account">
            {t("deleteAccount")}
          </CustomButton> */}
        </Inputs>
      </Container>
    </LoggedInBoilerplate>
  );
}
